import "./blogdashboard.css"
import { HelmetProvider } from 'react-helmet-async';
import BlogDashboardComponent from "../../../assets/components/03_blogdashboard/blogdashboardcomponent";
import BlogGridComponent from "../../../assets/components/04_bloggrid/bloggridcomponent";
import Header from "../../../assets/components/01_header/header"
import Footer from "../../../assets/components/02_footer/footer"

export default function BlogDashboard() {
  return (
    <div>
      <HelmetProvider>
                <title>Adstrate Blog Dashbaord</title>
                <meta name="All Adstrates blogs will be here to talk on digital marketing, social media management and other marketing industry topics" />
                <link rel="canonical" href="https://adstrate.in/blogs" />
            </HelmetProvider>
        <Header />
        <BlogDashboardComponent />
        <BlogGridComponent />
        <Footer />
    </div>
  );
}
